<template>
    <div class="biz-login" v-bind:style="{'min-height': myHeight}">
        <announcement></announcement>
        <div class="left">
            <div class="wrap">
                <div class="logo">
                    <img src="@/assets/img/flypig.svg" alt="">
                    飛豬管家
                </div>

                <h1 class="title" v-if="$route.name === 'bizExperienceLogin'">歡迎使用體驗帳號！</h1>
                <h1 class="title" v-else-if="status=='LOGIN'">歡迎回來！</h1>
                <h1 class="title" v-else>建立你的帳號</h1>
                <div class="board" @click="openAnnouncement()">
                    <img src="@/assets/img/pages/registerFlow/biz_login_alarm.svg" alt="">
                    <span>公告訊息</span>
                </div>
                <img class="sofa" src="@/assets/img/pages/registerFlow/biz_login.svg" alt="">
            </div>
        </div>
        <div class="right">
            <div class="wrap">
                <div class="login-wrap">
                    <div class="login-tabs">
                        <div :class="{active: status=='LOGIN'}" @click="status = 'LOGIN'">企業登入</div>
                        <div  v-if="$route.name !== 'bizExperienceLogin'" :class="{active: status=='REGISTER'}" @click="status = 'REGISTER'">企業註冊</div>
                    </div>
                    <login-comp v-if="status=='LOGIN'"></login-comp>
                    <register-comp v-if="status=='REGISTER'"></register-comp>
                </div>
            </div>
            <div class="right-and-private">
                <span class="company">
                    © {{year}} 方居浩斯科技股份有限公司版權所有
                </span>
                <div class="private"  v-if="$route.name !== 'bizExperienceLogin'"> 
                    <router-link :to="{ name: 'bizPrivacyPolicy'}">隱私權政策</router-link>
                </div>
                <div  v-if="$route.name !== 'bizExperienceLogin'">
                    <router-link :to="{ name: 'bizUserTerms'}">會員條款</router-link>
                </div>
            </div>
            <div class="right-and-private-mb">
                <div class="private-wrap">
                    <div class="private"  v-if="$route.name !== 'bizExperienceLogin'">
                        <router-link :to="{ name: 'bizPrivacyPolicy'}">隱私權政策</router-link>
                    </div>
                    <div  v-if="$route.name !== 'bizExperienceLogin'">
                        <router-link :to="{ name: 'bizUserTerms'}">會員條款</router-link>
                    </div>
                </div>
                <span class="company">
                    © {{year}} 方居浩斯科技股份有限公司版權所有
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import loginComp from '@/components/bussiness/registerFlow/login/loginComp.vue';
import registerComp from '@/components/bussiness/registerFlow/login/registerComp.vue';
import announcement from '@/components/bussiness/widges/modals/announcement.vue';

export default {
    data () {
        return {
            status: 'LOGIN',
            myHeight: (window.innerHeight) + 'px',
        }
    },
    watch: {
        $route:{
            handler: function (val) {
                // console.log(val)
                if( val.query.mode === 'register'){
                    this.status = 'REGISTER'
                }
            },
            immediate: true,
            deep: true
        },
    },
    methods: {
        openAnnouncement: function () {
            this.$store.dispatch('setModalStatus', {state: true, type: 'bizAnnouncement'})
            this.$analyticsBiz.logEvent('公告', { screen_name: '公告'})
        }
    },
    computed: {
        year: function () {
            let d = new Date();
            let year = d.getFullYear();

            return year
        },
    },
    components: {
        loginComp,
        registerComp,
        announcement
    }
}
</script>

<style lang="scss" scoped>
    .biz-login{
        display: flex;
        min-width: 1280px;
        .left{
            display: flex;
            align-items: flex-start;
            justify-content: center;
            width: 58.47%;
            background: #fff8e9;
            .wrap{
                width: 842px;
                padding: 50px 85px;
                box-sizing: border-box;
                .logo{
                    display: flex;
                    align-items: center;
                    color: #fb9479;
                    font-size: 30px;
                    margin-bottom: 59px;
                    >img{
                        width: 56px;
                        margin-right: 20px;
                    }
                }
                .title{
                    line-height: 1.5;
                    letter-spacing: 3px;
                    color: #443a37;
                    font-size: 50px;
                    margin-bottom: 40px;
                }
                .board{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 154px;
                    height: 44px;
                    font-size: 18px;
                    border-radius: 32px;
                    box-shadow: 0 4px 12px 0 #96caff;
                    background-color: #71aae5;
                    color: #ffffff;
                    margin-bottom: 80px;
                    cursor: pointer;
                    img{
                        margin-right: 6px;
                    }
                }
            }
        }
        .right{
            display: flex;
            align-items: center;
            justify-content: flex-start;
            flex-direction: column;
            width: 41.53%;
            background: #fff;
            .wrap{
                position: relative;
                .login-wrap{
                    width: 398px;
                    margin-top: 90px;
                    .login-tabs{
                        display: flex;
                        align-items: center;
                        margin-bottom: 52px;
                        >div{
                            position: relative;
                            font-size: 24px;
                            color: #d7d7d7;
                            margin-right: 60px;
                            cursor: pointer;
                            &.active{
                                font-size: 30px;
                                color: #28292d;
                                font-weight: bold;
                                &:after{
                                    content: '';
                                    position: absolute;
                                    display: block;
                                    height: 4px;
                                    width: 100%;
                                    bottom: -14px;
                                    border-radius: 4.5px;
                                    background-color: #ff9275;
                                }
                            }
                        }
                    }
                }
            }
            .right-and-private{
                margin-top: 103px;
                display: flex;
                align-items: center;
                font-size: 12px;
                color: #878787;
                a{
                    color: #878787;
                }
                .private{
                    position: relative;
                    margin: 0 23px;
                    &::before{
                        content: '';
                        width: 1px;
                        height: 11px;
                        background: #878787;
                        position: absolute;
                        left: -12px;
                        top: 2px;
                    }
                    &::after{
                        content: '';
                        width: 1px;
                        height: 11px;
                        background: #878787;
                        position: absolute;
                        right: -12px;
                        top: 2px;
                    }
                }

            }
            .right-and-private-mb{
                display: none;
            }
        }
    }
    @media screen and (max-width: 1280px) {
        .biz-login{
            .left{
                .wrap{
                    .title{
                        font-size: 48px;
                    }
                    .sofa{
                        width: 97%;
                    }
                }
            }
        }
    }
    @media screen and (max-width: 1024px) {
        .biz-login{
            display: block;
            min-width: unset;
            .left{
                display: flex;
                align-items: flex-start;
                justify-content: center;
                width: 100%;
                background: #fff8e9;
                .wrap{
                    width: unset;
                    height: 131px;
                    padding: 14px 0px;
                    box-sizing: border-box;
                    .logo{
                        color: #fb9479;
                        font-size: 19px;
                        margin-bottom: 18px;
                        >img{
                            width: 35px;
                            margin-right: 12px;
                        }
                    }
                    .title{
                        line-height: 1.5;
                        letter-spacing: 3px;
                        color: #443a37;
                        font-size: 26px;
                        margin-bottom: 0px;
                    }
                    .board{
                        position: absolute;
                        left: 20px;
                        width: 44px;
                        height: 44px;
                        margin-bottom: 0px;
                        img{
                            margin-right: 0px;
                        }
                        >span{
                            display: none;
                        }
                    }
                    .sofa{
                        display: none;
                    }
                }
            }
            .right{
                width: unset;
                .wrap{
                    width: 100%;
                    .login-wrap{
                        width: unset;
                        padding: 0 20px;
                        margin-top: 40px;
                        .login-tabs{
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            padding: 0 54px;
                            margin-bottom: 50px;
                            >div{
                                font-size: 18px;
                                margin-right: 0px;
                                &.active{
                                    font-size: 20px;
                                }
                            }
                        }
                    }
                }
                .right-and-private{
                    display: none;
                }
                .right-and-private-mb{
                    position: relative;
                    width: 100%;
                    display: block;
                    font-size: 12px;
                    color: #878787;
                    bottom: 0px;
                    left: 20px;
                    margin-top: 30px;
                    margin-bottom: 40px;
                    .private-wrap{
                        display: flex;
                        align-items: center;
                        margin-bottom: 8px;
                        a{
                            color: #878787;
                        }
                        .private{
                            position: relative;
                            margin-right: 23px;
                            &::after{
                                content: '';
                                width: 1px;
                                height: 11px;
                                background: #878787;
                                position: absolute;
                                right: -12px;
                                top: 2px;
                            }
                        }
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/bussiness/registerFlow/login.vue